import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import moment from "moment";
import { 
  apiError,
  customerLogSuccessful
} from "./customerLogSlice";
import {
  getList,
  getParamsList,
  postAdd,
  postEdit,
  postFormData,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";

//If user is login then dispatch redux action's are directly from here.


function* CustomerLogList({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          if (k == "start_date") {
            params[k] = moment(data[k]).format("YYYY-MM-DD");
          } else if (k == "end_date") {
            params[k] = moment(data[k]).format("YYYY-MM-DD");
          } else {
            params[k] = data[k];
          }
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/attendance/customerlog/", params);
    yield put(customerLogSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}


export function* watchGetCustomerLog() {
  yield takeEvery("customerLog/getCustomerLog", CustomerLogList);
}
function* customerLogSaga() {
  yield all([
    fork(watchGetCustomerLog),
  ]);
}

export default customerLogSaga;
